export default {
  label: 'Text Area',
  placeholder: '',
  description: '',
  tooltip: '',
  customClass: '',
  key: 'textArea',
  type: 'textareaComponent',
  rows: 3,
  input: true,
  autoExpand: false,
  defaultValue: {
    type: 'value',
    value: ''
  },
  validate: {
    required: false
  },
  isNew: true,
  amsField: '',
  hidden: false,
  disabled: false,
  hideLabel: false
};
